import { useQuery } from "@tanstack/react-query";
import { trainerAvailabilityApi } from "api/trainers/trainerAvailabilityApi";
import { QUERIES_KEYS } from "queries";

export const useTrainerAvailabilityAdmin = (trainerId: number) => {
  return useQuery({
    queryKey: QUERIES_KEYS.TRAINER_AVAILABILITY(trainerId),
    queryFn: () => trainerAvailabilityApi.fetchAvailability(trainerId),
    select: (res) => res.data,
  });
};
